import React, { Component } from 'react';
import { Col, Row, Card, Modal } from 'antd';
import ProductItem from "components/eCommerce/ProductItem";
import { auth, database } from "../../../firebase/firebase";

class BookGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      urlId: 0,
      series: {},
      books: [],
      isModalVisible: false,
      currentIframe: '',
      modalTitle: ''
    };
    //this.handleChange=this.handleChange.bind(this);
  }

  handleProductClick = (event, product, id) => {
    console.log('Click called', product);
    if (product.iframe) {
      console.log('Has iframe', product.iframe);
      let iframeUrl = product.iframe;
      
      // Force mobile view if on mobile device
      if (window.innerWidth <= 768) {
        const separator = iframeUrl.includes('?') ? '&' : '?';
        iframeUrl = `${iframeUrl}${separator}mobile=1&viewport=mobile`;
      }
      
      this.setState({
        currentIframe: iframeUrl,
        modalTitle: product.title || 'Contenido',
        isModalVisible: true
      });
    }
  }

  handleCloseModal = () => {
    this.setState({
      isModalVisible: false,
      currentIframe: '',
      modalTitle: ''
    });
  }

  getUserInformation(user) {
    //console.log("ALL USER INFO CALLED");
    var _this = this;
    database
      .collection("users")
      .where("email", "==", user.email)
      .get()
      .then(function(querySnapshot) {
        //console.log("ID: " + _this.state.urlId);
        querySnapshot.forEach(function(doc) {
          _this.setState({ user: doc.data() });
          doc.ref
            .collection("accesed_series")
            .where("series_id", "==", _this.state.urlId)
            .get()
            .then(function(snapshot) {
              var refArray = [];
              snapshot.forEach(function(series) {
                refArray.push(series.data());
              });
              //console.log(refArray);
              if (refArray.length == 0) {
                //console.log("NO ACCESS TO THIS BOOK");
              } else {
                database
                  .doc("series/" + _this.state.urlId)
                  .get()
                  .then(function(doc) {
                    if (doc.exists) {
                      var series = doc.data();
                      //console.log(series);
                      _this.setState({ series: series });
                        database
                          .collection("books")
                          .where("series","==",doc.id)
                          .get()
                          .then(function(snapshot) {
                            //console.log("BOOKS")
                            var arr = snapshot.docs.sort(function(a, b) {
                              if(a.data().title < b.data().title) { return -1; }
                              if(a.data().title > b.data().title) { return 1; }
                              return 0;
                            });
                            //console.log(snapshot.docs[0].data())
                              _this.setState({ books: arr });
                              
                            
                          });
                    } else {
                      //console.log("Series does not exist");
                    }
                  });
              }
            });
        });
      })
      .catch(function(error) {
        //console.log("Error gettin0g document:", error);
      });
  }

  componentDidMount() {
    const { urlId } = this.props.match.params;
    var _this = this;

    this.setState({ urlId: urlId });
    auth.onAuthStateChanged(user => {
      if (user) {
        _this.getUserInformation(user);
      }
    });
  }

  render() {
    return ( 
      <div>
				<Row>
					<Col key="ss" xl={16} lg={16} md={16} sm={24} xs={24}>
						<Card className={`gx-card-metrics`}>
							<h1 className="gx-product-title">{this.state.series.sponsor}</h1>
							<h4>{this.state.series.books_description}</h4>
							<p>{this.state.series.sponsor_message}</p>
							<p>{this.state.series.disclamer}</p>
						</Card>
					</Col>
					<Col key="1a" xl={8} lg={8} md={8} sm={24} xs={24}>
						<Card className={`gx-card-metrics`}>
							<img src={this.state.series.sponsor_logo} />
						</Card>
					</Col>
     
     
        {this.state.books.map((book, index) => (
          <Col key={index} xl={6} md={8} sm={24} xs={24}>
            <ProductItem key={index} grid product={book.data()} click={this.handleProductClick} />
          </Col>
        ))}
      </Row>
      <Modal
        title={this.state.modalTitle}
        visible={this.state.isModalVisible}
        onCancel={this.handleCloseModal}
        footer={null}
        width="100%"
        style={{ top: '5%' }}
        bodyStyle={{ height: '90vh', padding: 0, overflow: 'hidden' }}
        centered={window.innerWidth <= 768}
      >
        {console.log('Modal state:', this.state.isModalVisible, this.state.currentIframe)}
        {this.state.currentIframe && (
          <iframe
            src={this.state.currentIframe}
            style={{ 
              width: window.innerWidth <= 768 ? '320%' : '100%', 
              height: window.innerWidth <= 768 ? '320%' : '100%', 
              border: 'none',
              transform: window.innerWidth <= 768 ? 'scale(0.31)' : 'scale(1)',
              transformOrigin: '0 0'
            }}
            title={this.state.modalTitle}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
          />
        )}
      </Modal>
      </div>
    );
  }
}

export default BookGrid;